import apiClient from './api';

export const submitOrderForValidation = async (orderId, accountId) => {
  try {
    const { data } = await apiClient.post(
      `/api/validations/orders/${orderId}/submit-validation`,
      { accountId }
    );
    
    if (!data.succeeded) {
      throw new Error(data.errors?.[0] || 'Erreur lors de la soumission');
    }
    return data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Erreur lors de la soumission à la validation'
    );
  }
};

export const submitAccountForValidation = async (accountId, submittedByAccountId) => {
  try {
    const { data } = await apiClient.post(
      `/api/validations/accounts/${accountId}/submit-validation`,
      { submittedByAccountId }
    );
    
    if (!data.succeeded) {
      throw new Error(data.errors?.[0] || 'Erreur lors de la soumission');
    }
    return data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Erreur lors de la soumission à la validation'
    );
  }
};

// validationService.js
export const getValidationDetails = async (entityId, entityType) => {
  try {
    const { data } = await apiClient.get(
      `/api/validations/details`,
      { params: { entityId, entityType } }
    );
    
    if (!data.succeeded) {
      const errorMessage = data.message || "Une erreur est survenue.";
      const errorDetails = data.errors?.join(', ');
      throw new Error(errorDetails ? `${errorMessage}: ${errorDetails}` : errorMessage);
    }
    
    return data.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      error.message || 
      'Impossible de communiquer avec le serveur pour récupérer les détails.'
    );
  }
};

// Récupérer les stats complètes
export const getValidationStats = async (accountId, domainId) => {
  const { data } = await apiClient.get(`/api/Validations/stats`, {
    params: { accountId, domainId },
  });
  return data.data;
};

// Récupérer juste les counts
export const getValidationCounts = async (accountId, domainId) => {
  const { data } = await apiClient.get(`/api/Validations/counts`, {
    params: { accountId, domainId },
  });
  return data.data;
};

// Récupérer les urgents
export const getUrgentValidations = async (accountId, domainId) => {
  const { data } = await apiClient.get(`/api/Validations/urgent`, {
    params: { accountId, domainId },
  });
  return data.data;
};


export const validationService = {
  // Récupérer les tâches de validation avec pagination et filtres
  // Récupérer les tâches de validation avec pagination et filtres BACKEND
// validationService.js
  getMyValidationTasks: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      // Mapping des paramètres frontend → backend
      const paramMapping = {
        status: 'Status',
        entityType: 'EntityName', 
        search: 'SearchTerm',
        page: 'PageNumber',
        pageSize: 'PageSize',
        domainId: 'DomainId',
        sortColumn: 'SortColumn',
        sortOrder: 'SortOrder'
      };

      // Ajouter les paramètres mappés
      Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== '') {
          const backendParam = paramMapping[key] || key;
          params.append(backendParam, filters[key]);
        }
      });

      // Ajouter l'AccountId obligatoire
      if (!params.has('AccountId') && accountId) {
        params.append('AccountId', accountId);
      }

      const response = await apiClient.get(`/api/validations/mytasks?${params}`);
      
      return {
        success: true,
        data: response.data,
        error: null
      };
    } catch (error) {
      console.error('Erreur API:', error);
      return {
        success: false,
        data: null,
        error: error.response?.data?.message || 'Erreur serveur'
      };
    }
  },

  // Approuver une validation (CORRIGÉ selon votre API)
  // validationService.js
  // validationService.js - CORRECTION COMPLÈTE
approveValidation: async (entityType, entityId, accountId, comments = '') => {
  try {
    // console.log(" Envoi approbation:", { entityType, entityId, accountId, comments });
    
    // CORRECTION : Utiliser la bonne structure de données
    const requestData = {
      accountId: accountId,
      entityType: entityType,
      entityId: entityId,
      comments: comments 
    };

    // console.log("Données envoyées:", requestData);

    const response = await apiClient.post(
      `/api/validations/approve`,
      requestData  // Envoyer l'objet directement
    );

    // console.log("Réponse reçue:", response.data);

    if (!response.data.succeeded) {
      const errorMsg = response.data.errors?.[0] || 'Erreur lors de l\'approbation';
      throw new Error(errorMsg);
    }

    return {
      success: true,
      data: response.data,
      error: null
    };
  } catch (error) {
    // console.error('❌ Erreur détaillée:', error);
    
    // Gestion spécifique des erreurs
    if (error.response?.status === 500) {
      return {
        success: false,
        data: null,
        error: "Erreur serveur temporaire. Veuillez réessayer."
      };
    }
    
    const errorMessage = error.response?.data?.errors?.[0] || 
                        error.response?.data?.message || 
                        error.message || 
                        'Erreur technique lors de l\'approbation';
    
    return {
      success: false,
      data: null,
      error: errorMessage
    };
  }
},
  // Rejeter une validation (CORRIGÉ selon votre API)
  rejectValidation: async (validationId, accountId, comments) => {
    try {
      if (!comments || comments.trim() === '') {
        throw new Error('Un commentaire est obligatoire pour le rejet');
      }

      const response = await apiClient.post(
        `/api/validations/${validationId}/reject`,
        { 
          AccountId: accountId,  // Inclure l'AccountId comme demandé par l'API
          Comments: comments 
        }
      );

      if (!response.data.succeeded) {
        throw new Error(response.data.errors?.[0] || 'Erreur lors du rejet');
      }

      return {
        success: true,
        data: response.data,
        error: null
      };
    } catch (error) {
      // console.error('Erreur lors du rejet:', error);
      
      return {
        success: false,
        data: null,
        error: error.response?.data?.message || 
               error.message || 
               'Erreur lors du rejet de la validation'
      };
    }
  }
};